module.exports = __webpack_public_path__ + "img/3.563f6cf4.png";